module.exports = __webpack_public_path__ + "static/media/login.269ef431.png";